module.exports = __webpack_public_path__ + "img/xingfu.18ee3545.png";